
import React from 'react';
import { CorporateIcon, GasPumpIcon, ReceiptShortIcon } from '../../svgs/ExpressonSVGs';

type LoginPerksProps = {
	data?: any // TODO: Change this
}

/**
 * Showing perks with the mina sidor
 *
 * @returns 
 */
const LoginPerks: React.FC<LoginPerksProps> = ({ data }) => {
	return (
		<div className="login-perks">
			<h2 className="login-perks__title">
				Dina förmåner och information på ett ställe
			</h2>
			<div className="login-perks__wrapper">
				<div className="login-perks__item shadow-one">
					<span className="svg-icon-wrapper orange">
						<ReceiptShortIcon width={40} height={40} />
					</span>
					<h3>Full koll på dina köp</h3>
					<p>
						Se transaktioner, hantera kvitton och ladda ner fakturor. Allt samlat för enkel överblick.
					</p>
				</div>
				<div className="login-perks__item shadow-one">
					<span className="svg-icon-wrapper green">
						<GasPumpIcon width={40} height={40} />
					</span>
					<h3>Tankningar och saldo</h3>
					<p>
						Följ din förbrukning, se statistik över dina tankningar och kontrollera ditt kortsaldo direkt i mina sidor.
					</p>
				</div>
				<div className="login-perks__item shadow-one">
					<span className="svg-icon-wrapper blue">
						<CorporateIcon width={40} height={40} />
					</span>
					<h3>För företagskunder</h3>
					<p>
						Logga in för att hantera företagets fordon, kort och fakturor. Behörighet krävs och tilldelas av er administratör.
					</p>
				</div>
			</div>
		</div>
	)
}

export default LoginPerks